import { createTheme, MuiThemeProvider } from '@material-ui/core/styles'
import axios from 'axios'
import TagManager from 'react-gtm-module'
import { useDispatch } from 'react-redux'
import { Route, Switch, useHistory, useLocation } from 'react-router-dom'
import { logout } from './actions/userActions'
import './app.scss'
import ContactSupport from './components/ContactSupport/ContactSupport'
import ContactSupportToast from './components/ContactSupport/ContactSupportToast'
import CreateAQuote from './components/CreateAQuote/CreateAQuote'
import CreateProject from './components/CreateAQuote/CreateProject/CreateProject'
import QuoteSubmitted from './components/CreateAQuote/QuoteSubmitted/QuoteSubmitted'
import Footer from './components/Footer/Footer'
import Header from './components/Header/Header'
import HomePage from './components/HomePage/HomePage'
import Login from './components/Login/Login'
import ForgotPassword from './components/Login/SignIn/ForgotPassword'
import PasswordRecoverySent from './components/Login/SignIn/PasswordRecoverySent'
import PasswordResetSuccess from './components/Login/SignIn/PasswordResetSuccess'
import ResetPassword from './components/Login/SignIn/ResetPassword'
import AcceptInvite from './components/Login/SignUp/AcceptInvite'
import ConfirmEmail from './components/Login/SignUp/ConfirmEmail'
import SignUpComplete from './components/Login/SignUp/SignUpComplete'
import SignUpSuccess from './components/Login/SignUp/SignUpSuccess'
import Unsubscribe from './components/Marketing/Unsubscribe'
import MyQuality from './components/MyQuality/MyQuality'
import NotFound from './components/NotFound/NotFound'
import ProjectContextProvider from './providers/ProjectContextProvider'

const theme = createTheme({
  palette: {
    primary: {
      main: '#005072',
    },
    secondary: {
      main: '#b5dc79',
    },
    black: {
      main: '#000000',
    },
  },
})

const App = () => {
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()

  axios.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      if (error.response.status === 401) {
        dispatch(logout())
        history.push('/login')
      }
      throw error
    }
  )

  const tagManagerArgs = {
    gtmId: 'GTM-MFL6T33',
  }

  TagManager.initialize(tagManagerArgs)

  return (
    <MuiThemeProvider theme={theme}>
      <ProjectContextProvider>
        <>
          <Header />
          <main>
            <Switch>
              <Route path="/login" component={Login} />
              <Route path="/signup-success" component={SignUpSuccess} />
              <Route path="/confirm/:code" component={ConfirmEmail} />
              <Route path="/forgotpassword" component={ForgotPassword} />
              <Route
                path="/password-recovery-sent"
                component={PasswordRecoverySent}
              />
              <Route path="/reset-password/:code" component={ResetPassword} />
              <Route path="/password-reset" component={PasswordResetSuccess} />
              <Route path="/myquality/:location" component={MyQuality} />
              <Route path="/completesignup" component={SignUpComplete} />
              <Route path="/accept-invite/:id" component={AcceptInvite} />
              <Route path="/createaquote/:service" component={CreateProject} />
              <Route path="/createaquote/" component={CreateProject} />
              <Route path="/quote-submitted" component={QuoteSubmitted} />
              <Route path="/project/edit/:id" component={CreateAQuote} />
              <Route path="/unsubscribe/:email" component={Unsubscribe} />
              <Route path="/" exact component={HomePage} />
              <Route component={NotFound} />
            </Switch>
          </main>
          {!location.pathname.includes('myquality') && <Footer />}
          <ContactSupport />
          <ContactSupportToast />
        </>
      </ProjectContextProvider>
    </MuiThemeProvider>
  )
}

export default App
